import { render, staticRenderFns } from "./RedemptionList.vue?vue&type=template&id=3adbb018&"
import script from "./RedemptionList.vue?vue&type=script&lang=js&"
export * from "./RedemptionList.vue?vue&type=script&lang=js&"
import style0 from "./RedemptionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports